import { render, staticRenderFns } from "./PreviewConsulto.vue?vue&type=template&id=fd4d8ee6&scoped=true&"
import script from "./PreviewConsulto.vue?vue&type=script&lang=js&"
export * from "./PreviewConsulto.vue?vue&type=script&lang=js&"
import style0 from "./PreviewConsulto.vue?vue&type=style&index=0&id=fd4d8ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4d8ee6",
  null
  
)

export default component.exports